import api from "./index";

export const login = async (email, password) => {
  const res = await api.post("/users/login", { email, password });
  return res.data;
};

export const signup = async (email, password, location = {}) => {
  const payload = { email, password };
  if (location.country) payload.country = location.country;
  if (location.city) payload.city = location.city;
  if (location.region) payload.region = location.region;
  const res = await api.post("/users/signup", payload);
  return res.data;
};

export const verifyEmail = async (token) => {
  const res = await api.post("/users/verify-email", { token });
  return res.data;
};
